/**
 * Reading a refused charge-to-room.
 *
 * A table can stay open for hours after its guest was attached, and the guest may
 * check out in the meantime. Prostay checks at the moment of posting and answers
 * 409 with the sentence for the waiter ("…checked out at 14:41. Please select
 * another payment method"). Every place that posts to a room reads the answer
 * here, so all of them show that sentence instead of a status code or raw JSON.
 */

export const GUEST_CHECKED_OUT_TITLE = 'Guest has checked out';

/** Long enough to read the room, the time and what to do instead. */
export const GUEST_CHECKED_OUT_TOAST_MS = 10000;

export interface RoomChargeFailure {
    /** True when the guest has left; the order stays open for cash or card. */
    checkedOut: boolean;
    message: string;
}

export async function readRoomChargeFailure(response: Response, fallbackPrefix: string): Promise<RoomChargeFailure> {
    const text = await response.text().catch(() => '');
    if (response.status === 409) {
        try {
            const body = JSON.parse(text);
            if (body?.error === 'reservation-checked-out' && typeof body.message === 'string') {
                return { checkedOut: true, message: body.message };
            }
        } catch {
            // not JSON - fall through
        }
    }
    return { checkedOut: false, message: `${fallbackPrefix}: ${text}` };
}
